module.exports = __webpack_public_path__ + "img/SKMJ_saferoad5.e90bd52e.jpg";